module.exports = __webpack_public_path__ + "img/Default_hot.ed3d1052.jpg";